export default __webpack_public_path__ + "static/media/img_girl_with_books.eac8abd2.png";